var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccentStars02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 72,
    viewBox: "0 0 105 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21870_113016)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21870_113016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2209 18.4199C41.3844 18.2327 40.5288 18.6453 40.1162 19.3941C38.8137 21.7436 35.3263 27.6958 32.6448 29.1858C29.6921 30.8095 22.0068 30.8133 19.4857 30.7674C18.5652 30.7522 17.7286 31.3711 17.5415 32.2727C17.5415 32.2841 17.5377 32.2956 17.5338 32.3071C17.3734 33.1246 17.8089 33.9422 18.5423 34.3395C20.7463 35.5238 26.9686 39.0424 28.466 41.7396C30.1352 44.7425 30.0626 52.54 29.9901 55.0232C29.9671 55.7835 30.3797 56.5017 31.0634 56.8303C31.3079 56.9487 31.5753 57.0213 31.8426 57.0557C32.6028 57.1436 33.3362 56.7424 33.7181 56.0777C34.9519 53.9306 38.8901 47.3595 41.8351 45.7243C44.4899 44.2497 51.2661 44.4139 54.0049 44.5477C54.8987 44.5935 55.7123 44.0281 55.9797 43.1723C55.9911 43.1303 56.0026 43.0921 56.0141 43.05C56.2471 42.2057 55.8651 41.3156 55.1126 40.8686C52.7443 39.4703 46.7779 35.7531 45.2423 33.0291C43.7144 30.2402 43.8367 23.1763 43.9474 20.4714C43.9818 19.6233 43.4738 18.8363 42.6716 18.5536C42.5227 18.5001 42.3699 18.4581 42.2133 18.4237L42.2209 18.4199Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_21870_113016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3066 14.0405C75.8826 14.1284 75.577 14.5142 75.5464 14.9727C75.4433 16.4091 75.0957 20.092 74.179 21.4024C73.1667 22.8389 69.6373 24.4931 68.4723 25.0127C68.0444 25.2037 67.7923 25.6889 67.8955 26.1703C67.8955 26.1779 67.8955 26.1818 67.8993 26.1894C67.9986 26.6249 68.3691 26.9344 68.7893 26.9726C70.0498 27.0834 73.648 27.4769 74.9009 28.4816C76.2989 29.601 77.9071 33.4558 78.3998 34.6936C78.5488 35.0719 78.8887 35.3393 79.2745 35.3507C79.412 35.3546 79.5495 35.3354 79.6794 35.2934C80.0461 35.175 80.2982 34.8159 80.3326 34.4071C80.4472 33.0852 80.8712 29.0012 81.8758 27.5609C82.7811 26.262 85.9285 24.8866 87.212 24.3632C87.6322 24.1913 87.8881 23.7405 87.827 23.263C87.827 23.24 87.8193 23.2171 87.8193 23.1942C87.7506 22.7281 87.3839 22.3728 86.9446 22.3155C85.5618 22.1359 82.0438 21.5896 80.7642 20.581C79.477 19.5381 78.0446 16.0309 77.5251 14.6747C77.3608 14.2506 76.9636 13.9717 76.5358 14.0023C76.4555 14.0099 76.3753 14.0214 76.2989 14.0367L76.3066 14.0405Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_21870_113016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8374 25.1085C55.6999 25.2117 55.6578 25.4065 55.7266 25.5746C55.9405 26.1095 56.4562 27.5001 56.3569 28.1305C56.2423 28.8219 55.2644 30.0292 54.9359 30.4189C54.8175 30.5603 54.8099 30.778 54.9321 30.9385C54.9321 30.9385 54.9321 30.9423 54.9359 30.9461C55.0467 31.0875 55.2339 31.1333 55.3905 31.076C55.8603 30.8964 57.2201 30.4189 57.8466 30.5641C58.5418 30.7284 59.7908 31.8401 60.1843 32.203C60.3027 32.3138 60.4707 32.352 60.6121 32.2909C60.6617 32.268 60.7076 32.2374 60.7458 32.1992C60.8565 32.0922 60.8833 31.9203 60.826 31.7675C60.635 31.2708 60.0773 29.7236 60.1881 29.0321C60.2874 28.4094 61.1774 27.3664 61.5479 26.9576C61.6701 26.8239 61.6816 26.6176 61.5785 26.4533C61.5746 26.4457 61.567 26.438 61.5632 26.4304C61.4562 26.2738 61.2653 26.2088 61.0972 26.2623C60.5701 26.4342 59.2102 26.8468 58.5761 26.7016C57.9306 26.5488 56.8076 25.5288 56.3836 25.1276C56.2499 25.0015 56.0589 24.971 55.91 25.055C55.8832 25.0703 55.8565 25.0894 55.8297 25.1085H55.8374Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21870_113016",
    x: 1.50098,
    y: 2.375,
    width: 70.5811,
    height: 70.6929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.65098 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21870_113016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21870_113016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_21870_113016",
    x: 51.8721,
    y: -2,
    width: 51.9639,
    height: 53.3511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.65098 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21870_113016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21870_113016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_21870_113016",
    x: 38.8438,
    y: 9.00781,
    width: 38.8047,
    height: 39.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.65098 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21870_113016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21870_113016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21870_113016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccentStars02);
export default __webpack_public_path__ + "static/media/Accent_Stars_02.14687fdb6ec313c6d25102e203fc696e.svg";
export { ForwardRef as ReactComponent };